/* eslint-disable jsx-a11y/label-has-associated-control */
import { useMsal } from "@azure/msal-react";
import moment from "moment";
import { addLocale } from "primereact/api";
import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import InputMask from "react-input-mask";

import { axiosGetRequest, axiosPostRequest } from "../../../api/ApiClient";
import AutocompleteAbono from "../../../components/AutocompleteAbono";
import DialogMessage from "../../../components/DialogMessage";
import { ptBrDatepickerTranslations } from "../../../i18n/locales/pt-br";
import SelectOption from "../../../model/SelectOption";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import CheckRadioStyles from "../../../styles/components/CheckRadioStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import InputCalendarStyles from "../../../styles/components/InputCalendarStyles";
import { StyledInfoText } from "../../../styles/pages/Schedule/ModalViewDetailsStyles";
import GenericUtils from "../../../utils/GenericUtils";
import { Routes } from "../../../model/Enums/RoutesEnum";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { BtnPrimary } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

export default function ContentEsquecimento(props: any) {
    const { setSuccessMessage } = props;
    const [abonos, setAbonos] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const acessToken = GenericUtils.getAccessTokenDocente();
    const [validacoes] = useState<any>(true);
    const { instance } = useMsal();
    const [errorTitle, setErrorTitle] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [selected, setSelected] = useState<any[]>([]);
    const [datePicker, setDatePicker] = useState<any>(null);
    const [periodoAbono, setPeriodoAbono] = useState(1);
    const [telefone, setTelefone] = useState("");
    const [rangeTime, setRangeTime] = useState("");
    const [qtdDias, setQtdDias] = useState("0");
    const { docente } = props.props;
    const location = useLocation();

    const getAbonos = async () => {
        const newAbonos: SelectOption[] = [];
        setDatePicker(moment(props.props.detail?.data).toDate());
        const response = await axiosGetRequest(
            `/docente/v1/tipo-abono?_limit=500000&ativos=true`,
            acessToken,
            instance
        );
        response?.data?.map((data: any) =>
            newAbonos.push({
                value: data.tipoAbonoID,
                label: data.motivo,
            })
        );
        setAbonos(newAbonos);
    };

    useEffect(() => {
        getAbonos();
        setIsLoading(false);
    }, []);

    function validacoesFields() {
        if (periodoAbono === 1) {
            return (
                Number(qtdDias) > 0 &&
                telefone.replace(/\D/g, "").length === 11 &&
                datePicker !== null &&
                selected.length > 0
            );
        }
        if (periodoAbono === 2) {
            return (
                rangeTime !== "" &&
                telefone.replace(/\D/g, "").length === 11 &&
                datePicker !== null &&
                selected.length > 0
            );
        }
        return false;
    }

    const dialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorTitle)}
            title={errorTitle}
            text={errorMessage}
            onClose={() => {
                setErrorTitle("");
                setErrorMessage("");
            }}
        />
    );

    const handleSendJustificativa = async () => {
        const periodoInicioAux = rangeTime.split(" às ")[0];
        const periodoFimAux = rangeTime.split(" às ")[1];
        const pathLocation = location.pathname.split("/");

        const { horaInicio, horaFim } = props.props.detail;
        const horaAbonoMenorHoraAula = periodoInicioAux <= horaInicio;
        const HoraAbonoMaiorHoraAula = periodoFimAux >= horaFim;
        const isValidAbono =
            periodoAbono !== 2 ||
            horaAbonoMenorHoraAula ||
            HoraAbonoMaiorHoraAula;

        if (isValidAbono) {
            const response = await axiosPostRequest(
                `/docente/v1/agendas/${props.props.detail.cartaoAgendaId}/justificar-abono-legal`,
                {
                    docenteId: docente.docenteID,
                    tipoAbonoID: selected[0]?.value,
                    data: datePicker.toISOString().split("T")[0],
                    tipo: periodoAbono === 1 ? "D" : "P",
                    quantidadeDias: qtdDias,
                    periodoInicio:
                        periodoInicioAux !== "" ? periodoInicioAux : undefined,
                    periodoFim: periodoFimAux,
                    email: docente.emailProfessor,
                    telefone,
                    minhaAgenda: pathLocation[1] === Routes.MinhaAgenda,
                },
                acessToken,
                instance
            );

            if (response.status === 201) {
                setSuccessMessage(true);
            } else {
                setErrorTitle("Erro ao Justificar.");
                setErrorMessage(response.data.details);
            }
        } else {
            setErrorTitle("Erro ao Justificar");
            setErrorMessage(
                `O Abono por Período deve ser cadastrado incluindo o horário do cartão selecionado: Início ${horaInicio}, Fim: ${horaFim}.`
            );
        }
    };

    const CheckHorario = (e: string) => {
        try {
            const inicio = e.split(" às ")[0];
            const fim = e.split(" às ")[1];
            const hora1 = inicio.split(":")[0];
            const minuto1 = inicio.split(":")[1];
            const hora2 = fim.split(":")[0];
            const minuto2 = fim.split(":")[1];

            if (Number(hora1) > 23 || Number(minuto1) > 59) {
                return false;
            }
            if (!Number(hora1 + 1)) return false;
            // eslint-disable-next-line sonarjs/prefer-single-boolean-return
            if (!Number(minuto1 + 1)) return false;

            if (Number(hora2) > 23 || Number(minuto2) > 59) {
                return false;
            }
            if (!Number(hora2 + 1)) return false;
            // eslint-disable-next-line sonarjs/prefer-single-boolean-return
            if (!Number(minuto2 + 1)) return false;

            const date2 = new Date(`2000-01-01 ${hora2}:${minuto2}:00`);
            const date1 = new Date(`2000-01-01 ${hora1}:${minuto1}:00`);

            // eslint-disable-next-line sonarjs/prefer-single-boolean-return
            if (date1.getTime() > date2.getTime()) return false;

            return true;
        } catch (error: any) {
            return false;
        }
    };

    return (
        <>
            <div style={{ marginTop: 20 }}>
                <AutocompleteAbono
                    onChange={setSelected}
                    options={abonos}
                    placeholder="Selecionar o Tipo de Abono Legal"
                    selected={selected}
                    extraOptions={false}
                    className="bold-placeholder"
                />
                <InputCalendarStyles.StyledCalendar
                    placeholder="Data de início do abono"
                    dateFormat="dd/mm/yy"
                    locale="pt-BR"
                    showButtonBar
                    readOnlyInput
                    disabled
                    value={datePicker}
                    onChange={(e: any) => setDatePicker(e.target?.value)}
                />
            </div>
            <div style={{ display: "flex", marginTop: 20, marginBottom: 20 }}>
                <CheckRadioStyles.StyledFormCheck
                    inline
                    label="Abono diário"
                    name="group5"
                    type="radio"
                    id="inline-5"
                    checked={periodoAbono === 1}
                    onChange={() => {
                        setPeriodoAbono(1);
                    }}
                />
                <CheckRadioStyles.StyledFormCheck
                    inline
                    label="Abono por período"
                    name="group4"
                    type="radio"
                    id="inline-4"
                    checked={periodoAbono === 2}
                    onChange={() => {
                        setPeriodoAbono(2);
                    }}
                />
            </div>
            {periodoAbono === 1 && (
                <div>
                    <Col>
                        <div className="form-floating">
                            <input
                                type="number"
                                className="form-control"
                                id="Quantidade1"
                                placeholder="00:00"
                                min="0"
                                max="99"
                                value={qtdDias}
                                onChange={(e) => setQtdDias(e.target.value)}
                                required
                            />
                            <label htmlFor="Quantidade1">
                                Quantidade de dias para abono
                            </label>
                        </div>
                    </Col>
                </div>
            )}
            {periodoAbono === 2 && (
                <div>
                    <Col>
                        <div>
                            <div className="form-floating">
                                <InputMask
                                    mask="99:99 às 99:99"
                                    className="form-control"
                                    id="MinutosIniciais"
                                    placeholder="00:00 às 00:00"
                                    style={{
                                        marginTop: 9,
                                        width: "100%",
                                        color: CheckHorario(rangeTime)
                                            ? "black"
                                            : "red",
                                        borderColor: CheckHorario(rangeTime)
                                            ? "#787878"
                                            : "red",
                                    }}
                                    onBlur={(_e) =>
                                        CheckHorario(rangeTime)
                                            ? null
                                            : setRangeTime(``)
                                    }
                                    onChange={(e) =>
                                        setRangeTime(`${e.target.value}`)
                                    }
                                    value={rangeTime}
                                    required
                                />
                                <label htmlFor="Quantidade1">Período</label>
                            </div>
                        </div>
                    </Col>
                </div>
            )}
            <div style={{ marginTop: 10 }}>
                <Col>
                    <div className="form-floating">
                        <input
                            className="form-control"
                            id="email"
                            value={docente.emailProfessor}
                            disabled
                        />
                        <label htmlFor="email">E-mail</label>
                    </div>
                </Col>
            </div>
            <div style={{ marginTop: 10 }}>
                <Col>
                    <div className="form-floating">
                        <InputMask
                            mask="(99) 99999-9999"
                            className="form-control"
                            id="MinutosIniciais"
                            placeholder="00:00"
                            value={telefone}
                            onChange={(e) => setTelefone(`${e.target.value}`)}
                            required
                        />
                        <label htmlFor="email">Telefone</label>
                    </div>
                </Col>
            </div>
            <StyledInfoText
                style={{
                    color: "red",
                }}
            >
                {validacoes?.code === 400 ? validacoes?.details : ""}
            </StyledInfoText>
            <StyledContainerButton className="mt-3">
                <BtnPrimary
                    disabled={isLoading || !validacoesFields()}
                    onClick={handleSendJustificativa}
                >
                    Confirmar
                </BtnPrimary>
            </StyledContainerButton>
            {errorMessage && dialogError}
        </>
    );
}
